import React from 'react';
import { X, Brain } from 'lucide-react';

const FeaturePill = ({ icon: Icon, label, color, onRemove, children }) => {
  return (
    <div
      className={`
        inline-flex items-center gap-1.5
        px-3 py-1
        rounded-full
        text-sm
        font-medium
        ${color}
        transition-colors
        duration-150
      `}
    >
      <Icon size={14} />
      <span>{label}</span>
      {children}
      <button
        onClick={onRemove}
        className="ml-0.5 hover:opacity-70 transition-opacity"
        aria-label={`Remove ${label}`}
      >
        <X size={14} />
      </button>
    </div>
  );
};

const FeaturePills = ({
  isThinking,
  isDeepResearch,
  reasoningLevels = [],
  onRemoveThinking,
  onRemoveDeepResearch
}) => {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {isThinking && reasoningLevels.length === 0 && (
        <FeaturePill
          icon={Brain}
          label="Thinking"
          color="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
          onRemove={onRemoveThinking}
        />
      )}

      {isDeepResearch && (
        <FeaturePill
          icon={Brain}
          label="Research"
          color="bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300"
          onRemove={onRemoveDeepResearch}
        />
      )}
    </div>
  );
};

export default FeaturePills;
